<list-view *ngIf="listeProfilConnexion" [liste]="listeProfilConnexion"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>
